import { useQuery } from '@tanstack/react-query'

import { reviewsApi, reviewKeys, QUALITY_RATING_NAME } from '../lib'

/**
 * Hook for fetching review ratings metadata
 *
 * Note: No useMemo needed - this hook is consumed by useReviewsState (not a Provider).
 * React 19 Compiler handles memoization automatically.
 */
export function useReviewRatings() {
  const query = useQuery({
    queryKey: reviewKeys.ratings(),
    queryFn: async () => {
      const data = await reviewsApi.getRatingsMetadata()
      return data.productReviewRatingsMetadata.items || []
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  })

  const neededRating = query.data?.find((rating) => rating.name === QUALITY_RATING_NAME)

  return {
    ratings: query.data || [],
    neededRating,
    loading: query.isLoading,
    error: query.error,
  }
}
